<!-- Шаблон создания записи на прием пациентом -->


<template>
	<section v-if="isShowed && logged">
		<div class="back_lay" @click="close"></div>

		<div class="appointment">

			<!-- Modal -->
			<div class="modal modal_shadow">

				<div @click="showDoctor(work)" class="modal__header clear_fix">
					<user-avatar :data="work" :set-class="'modal__avatar'"></user-avatar>
					<div class="modal__title">{{work.user_last_name}} {{work.user_first_name}} {{work.user_middle_name}}</div>
				</div>

				<!-- Outer -->
				<div class="modal__outer">
					<div class="modal__inner clear_fix">

						<div class="modal__date-box fl_l">
							<div class="modal__title bold">Дата</div>
							<div class="modal__date-item" @click="changeDate">
								<div class="modal__date">{{[selectedDate, 'DD-MM-YYYY'] | moment('DD.MM')}}</div>
								<div class="modal__day">{{[selectedDate, 'DD-MM-YYYY'] | moment('dd')}}</div>
							</div>
							<a class="modal__link modal__link_dark" @click="changeDate">Изменить<br> дату</a>
						</div>

						<div class="modal__time-box fl_l">
							<div class="modal__title bold">Выберите время</div>
							<div class="modal__item-wrap clear_fix time_fix">
								<div v-if="!tooFar" class="modal__item-time" :class="{'selected': time == tm}" v-for="tm in possibleTime"
										 @click="setTime(tm)">
									{{tm | local}}
								</div>

								<p v-if="!possibleTime.length && !tooFar" class="modal__basic-text fl_l">
									Нет доступной быстрой записи. Позвоните в клинику, чтобы выбрать наиболее удобное время. <span v-if="work.clinic_phones">Телефон <a :href="'tel:+' + work.clinic_phones">{{work.clinic_phones}}</a></span>
								</p>
								<p v-if="tooFar">
									Запись более, чем на неделю вперед производится только по телефону. <span v-if="work.clinic_phones">Звоните <a :href="'tel:+' + work.clinic_phones">{{work.clinic_phones}}</a></span>
								</p>

							</div>
						</div>
					</div>
					<div class="modal__inner">
						<form class="modal__form modal__form_pad" @submit.prevent="save">
							<div v-if="!isInquiry">
								<label class="modal__label">Коментарий</label>
								<textarea class="modal__text-field" v-model="recordModel.description"
													placeholder="Введите текст"></textarea>

								<!-- Checkbox -->
								<div class="checkbox basic__checkbox">
									<label class="checkbox__label">
										<input class="checkbox__input" type="checkbox" v-model="recordModel.access">
										<span class="checkbox__custom-input basic__checkbox-custom-input"></span>
										<span class="checkbox__text basic__checkbox-pad basic__checkbox-text">Дать доступ доктору ко всем записям в мед карте (рекомендуется)</span>
									</label>
								</div>
								<!-- Checkbox End -->
							</div>

							<div class="modal__btn-wrap">
								<input type="submit" class="modal__btn modal__btn_decor" value="Создать запись">
							</div>

							<p v-show="isWarn" class="modal__basic-text modal__basic-text_red">
								Пожалуйста выберите время
							</p>

						</form>
					</div>
				</div>
				<!-- Outer End -->
				<i class="modal__icon_close icon ion-close trans" @click="close"></i>
			</div>
			<!-- Modal End -->

		</div>

		<date-picker v-if="isPicker" language="ru" monday-first :disabled="onlyNext" v-model="convertedDate" :inline="true" @selected="updateDate"
								 class="centered_picker"></date-picker>
	</section>

</template>

<script>
	import moment from 'moment'
	import DatePicker from 'vuejs-datepicker'
	import Time from '../../common/UTC'

	export default {
		name: "Appointment",
		components: {DatePicker},
		filters: {
			local(value) {
				return Time.toLocal(value)
			}
		},
		computed: {
			begin() {
				if(!this.selectedDate || !this.time) {
					return false
				}

				return moment(this.selectedDate + ' ' + Time.toLocal(this.time), 'DD-MM-YYYY HH:mm').format('X')
			},
			user() {
				return this.$store.state.auth.user
			},
			logged() {
				return this.$store.state.auth.logged
			},
			isInquiry() {
				return this.work.can === 'by_request'
			}
		},
		mounted() {
			this.$event.connect('openAppointment', (work) => {

				if(!this.logged) {
					this.$event.toast('i', 'Для записи на прием, пожалуйста, авторизируйтесь или пройдите регистрацию');
					localStorage.setItem('pageBeforeLogin', this.$route.fullPath)
					this.$router.push('/login')
					return;
				}

				this.work = work
				this.isShowed = true

				this.onlyNext.to = new Date(moment().subtract('day', 1).format('X') * 1000);
				this.getFreeTime(moment().format());
			})

			this.$event.connect('closeAppointment', this.close.bind(this));
		},
		beforeDestroy() {
			this.$event.disconnect(['openAppointment', 'closeAppointment'])
		},
		data() {
			return {
				recordModel: {
					access: true,
					description: '',
					status: 'confirmed'
				},
				time: '',
				selectedDate: moment().format('DD-MM-YYYY'),
				convertedDate: '',
				isPicker: false,
				onlyNext: {
					to: ''
				},
				possibleTime: [],
				isShowed: false,
				isWarn: false,
				work: {},
				tooFar: false // Временная переменная, если выбранная дата позже чем на 7 дней, то выбор времени будет не доступен пациенту
			}
		},
		methods: {
			getFreeTime(date) {
				this.$store.dispatch('worker/getFreeTime', {
					id: this.work._id,
					day: moment(date).add(3, 'hours').format('X')
				}).then(time => this.possibleTime = time)
			},
			setTime(time) {
				this.time = time
			},
			changeDate() {
				this.isPicker = true
				this.convertedDate = moment(this.selectedDate, 'DD-MM-YYYY').format()
			},
			updateDate(date) {
				this.selectedDate = moment(date).format('DD-MM-YYYY')
				// Временное решение касательно доступа к рассписанию
				let gapDate = Number(moment(date).format('DDD')) - Number(moment(new Date()).format('DDD'))
				this.tooFar = (gapDate > 6 || (gapDate > -360 && gapDate < 0)) ? true : false

				this.isPicker = false
				this.time = '';
				this.getFreeTime(date)
			},
			close() {
				this.isShowed = false
				this.work = {}
				this.time = ''
				this.selectedDate = moment().format('DD-MM-YYYY')
				this.convertedDate = ''
				this.tooFar = false
			},
			showDoctor(work) {
				this.$router.push({
					name: 'SingleDoctor',
					query: {
						id: work.user_id
					}
				})


				this.close()
			},
			save() {
				if(!this.time) {
					this.isWarn = true
					return false
				} else {
					this.isWarn = false
				}

				if(this.work.can === 'yes') {
					this.recordModel.user_ids = [this.user._id]
					this.recordModel.worker_ids = [this.work._id]
					this.recordModel.clinic_id = this.work.clinic_id

					this.recordModel.begin = moment(this.begin, 'X').format('X')
					this.recordModel.end = moment(this.begin, 'X').add(this.work.time, 'minutes').format('X')

					this.$store.dispatch('agenda/create', this.recordModel).then(() => {
						this.$event.toast('s', 'Визит успешно создан')
						this.close()
					})
				} else if(this.work.can === 'by_request') {
					this.$store.dispatch('inquiry/create', {
						user_id: this.user._id,
						clinic_id: this.work.clinic_id,
						worker_id: this.work._id,
						begin: this.begin,
						end: moment(this.begin, 'X').add(this.work.time, 'minutes').format('X'),
					}).then(() => {
						this.$event.toast('s', 'Заявка успешно создана')
						this.close()
					})
				}
			}
		}
	}
</script>

<style scoped>
	.modal__header {
		cursor: pointer;
	}
	.appointment {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 510;
		background: white;
	}

	.centered_picker {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 520;
	}

	.time_fix {
		max-height: 300px;
		overflow: auto;
	}

	.selected {
		background-color: #00cbe2;
	}
	.modal__date-item, .modal__item-time {
		cursor: pointer;
	}
</style>

<style>

	.back_lay {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 500;
	}

</style>



// WEBPACK FOOTER //
// Appointment.vue?db8b4b1a